//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import { clientGET } from 'Core/data/RestApi';
//Action Types
import {
	EDIT_UNIT_OPEN,
	EDIT_UNIT_UPDATE,
	EDIT_UNIT_SEND_OTA,
	EDIT_UNIT_SEND_PING,
	EDIT_UNIT_DECODE_VIN
} from 'Redux/actionTypes';

//Actions
import {
	unitEditUnitOpenResult,
	unitEditUpdateResult,
	sendOtaResult,
	sendPingResult,
	AlertsCreateSystemAlert,
	AlertsUpdateSystemAlert,
	decodeVinResponse,
	deleteAlerts,
	unitEditUnitClose
} from 'Redux/actions';
import { upsertManyWithRules as upsertRealtimeUnits } from 'Core/realtime/redux/unitSlice';
import { upsertManyWithRules as upsertRealtimeLastReadings } from 'Core/realtime/redux/lastReadingSlice';
import { upsertManyWithRules as upsertRealtimeAssets } from 'Core/realtime/redux/assetSlice';
import { config } from 'react-transition-group';

export function* requesGetUnit() {
	yield takeEvery(EDIT_UNIT_OPEN, function* ({ payload }) {
		const { id } = payload;
		try {

			let data = yield call(
				clientQuery,
				`
				query {
					unit: getUnit (id: ${id}) {
						id
						label
						type
						hid
						esn
						imei
						driverId
						driverName
						defaultDriverId
						unitVersionId
						unitVersionProduct
						deviceCategory
						odometerEnable
						hoursEnable
						tags {
							id
							label
							color
							parentId
							path
							hasChildren
						}
						lastReading {
							accountId
							deviceId
							unitId
							unitType
							deviceLabel
							driverId
							driverName
							make
							model
							vin
							year
							deviceNote
							unitTime
							serverTime
							LastMessageTime
							eventCode
							eventName
							heading
							latitude
							longitude
							address {
								address
								city
								formatted
								state
								zip
							}
							distance
							speed
							speedLimit
							speedLimitRequest
							engineHours
							engineOdometer
							satelliteCount
							datacenter
							messageSource
							region
							republish
							rowId
							sequenceNumber
							unitDiagnostic
							starterSupported
							starterDisabled
							temperatures
							landmark_id
							lm
							landmarkEntered
							landmarkgroup_id
							landmarkname
							landmarkExited
							jobsite_id
							jobsiteEntered
							jobsiteExited
							jobsitename
							dtc
							desiredStarterState
							desiredStarterUpdated 
							ecuEngineHours
							ecuEngineOdometer
							ecuVin
							ecuSpeed
						}
						locationId
						location {
							id
							title
							active
						}
						useEcuOdometer
						offsetEngineOdometer
						offsetEcuEngineOdometer
						useEcuEngineHours
						offsetEngineHours
						offsetEcuEngineHours
						useEcuSpeed
						timeZoneId
						timeZone {
							id
							name
						}
						useEcuVin
						inputs {
							unitId
							position
							labelId
							onLabel
							offLabel
						}
						notes
						offsetEngineOdometerUpdatedOn
						offsetEcuEngineOdometerUpdatedOn
						offsetEngineHoursUpdatedOn
						offsetEcuEngineHoursUpdatedOn
						supportedOutputs
						supportedInputs
						outputs {
							unitId
							position
							name
							type
							state
						}
						alertContacts {
							id
							title
							address
							type
						}
						vehicleStatusId
						vbus
						jbus
						manufacturerId
						tow
						lowBattery
						motion
						ttu
						driverBehavior
						unitVersionDriverBehavior
						consistentSpeed
						consistentDuration
						noGps
						noGpsTimes
						noGpsDays
						obd2alerts
						vbusConfiguration
						starter
					}
				}`,
				{
					id: id
				},
				endpoints.GRAPHQL_GENERAL,
			);

			let asset = yield call(
				clientQuery,
				`
				query {
					data: getUnit (id: ${id}) {
						asset {
							id
                engine
								label
								licensePlate
								make
								model
								mpgCity
								mpgHighway
								unitId
								vin
								year
						}
					}
				}`,
				{
					id: id
				},
				endpoints.GRAPHQL_GENERAL_V2,
			);

			if (data) {
				if(!data?.unit){
					//if no have data, dont show the modal
					yield put(unitEditUnitClose())
				}else{
					yield put(unitEditUnitOpenResult({
						...data.unit,
						asset: asset?.data?.asset,
						driverBehaviorAlert: data.driverBehavior,
						towAlert: data.tow,
						motionAlert: data.motion,
						consistentSpeedAlert: data.consistentSpeed,
					}));
				}
			} else {
				yield put(unitEditUnitOpenResult());
			}
		} catch (exc) {
			ExceptionManager(
				exc,
				'modules/units/components/editUnit/redux/saga',
				'requesGetUnit',
			);
			yield put(unitEditUnitOpenResult());
		}
	});
}

export function* requesUpdateUnit() {
	yield takeEvery(EDIT_UNIT_UPDATE, function* ({ payload }) {
		try {
			const { unit, inputs, outputs, systemAlerts, systemAlertsToDelete } = payload;
			const {
				id, label, type, hid, esn, imei, driverId, unitVersionId, deviceCategory, locationId,
				useEcuOdometer, offsetEngineOdometer, offsetEcuEngineOdometer, useEcuEngineHours, offsetEngineHours,
				offsetEcuEngineHours, useEcuSpeed, timeZoneId, useEcuVin, notes,
				offsetEngineOdometerUpdatedOn, offsetEcuEngineOdometerUpdatedOn, offsetEngineHoursUpdatedOn,
				offsetEcuEngineHoursUpdatedOn, asset, vehicleStatusId,

				lowBattery, noGps, noGpsTimes, noGpsDays, consistentSpeed, consistentDuration, tagIds, alertContacts, defaultDriverId,

				obd2alerts, vbus,
				jbus
			} = unit;

			let data = yield call(
				clientMutation,
				` 
				mutation updateUnit (
					$id: Int!, 
					$label: String, 
					$type: String, 
					$hid: String, 
					$esn: String, 
					$imei: String, 
					$driverId: Int, 
					$unitVersionId: Int, 
					$deviceCategory: enumDeviceCategory, 
					$locationId: Int, 
					$useEcuOdometer: Boolean, 
					$offsetEngineOdometer: Float, 
					$offsetEcuEngineOdometer: Float, 
					$useEcuEngineHours: Boolean, 
					$offsetEngineHours: Float, 
					$offsetEcuEngineHours: Float, 
					$useEcuSpeed: Boolean, 
					$timeZoneId: Int, 
					$useEcuVin: Boolean, 
					$notes: String, 
					$offsetEngineOdometerUpdatedOn: AWSDateTime, 
					$offsetEcuEngineOdometerUpdatedOn: AWSDateTime, 
					$offsetEngineHoursUpdatedOn: AWSDateTime, 
					$offsetEcuEngineHoursUpdatedOn: AWSDateTime,
					$vehicleStatusId: Int,
					$consistentSpeed: Int,
					$consistentDuration: Int,
					$lowBattery: Int,
					$noGps: Int,
					$noGpsTimes: Int,
					$noGpsDays: Int, 
					$tagIds: [Int],
					$alertContacts: [Int],
					$driverTransitionFrom: String,
					$defaultDriverId: Int
				) {
					updateUnit (
						id: $id, 
						label: $label, 
						type: $type, 
						hid: $hid, 
						esn: $esn, 
						imei: $imei, 
						driverId: $driverId, 
						unitVersionId: $unitVersionId, 
						deviceCategory: $deviceCategory, 
						locationId: $locationId, 
						useEcuOdometer: $useEcuOdometer, 
						offsetEngineOdometer: $offsetEngineOdometer, 
						offsetEcuEngineOdometer: $offsetEcuEngineOdometer, 
						useEcuEngineHours: $useEcuEngineHours, 
						offsetEngineHours: $offsetEngineHours, 
						offsetEcuEngineHours: $offsetEcuEngineHours, 
						useEcuSpeed: $useEcuSpeed, 
						timeZoneId: $timeZoneId, 
						useEcuVin: $useEcuVin, 
						notes: $notes, 
						offsetEngineOdometerUpdatedOn: $offsetEngineOdometerUpdatedOn, 
						offsetEcuEngineOdometerUpdatedOn: $offsetEcuEngineOdometerUpdatedOn, 
						offsetEngineHoursUpdatedOn: $offsetEngineHoursUpdatedOn, 
						offsetEcuEngineHoursUpdatedOn: $offsetEcuEngineHoursUpdatedOn,
						vehicleStatusId: $vehicleStatusId,
						consistentSpeed: $consistentSpeed,
						consistentDuration: $consistentDuration,
						lowBattery: $lowBattery,
						noGps: $noGps,
						noGpsTimes: $noGpsTimes,
						noGpsDays: $noGpsDays, 
						tagIds: $tagIds,
						alertContacts: $alertContacts,
						driverTransitionFrom: $driverTransitionFrom,
						defaultDriverId: $defaultDriverId
					) {
						id
					}
				}`,
				{
					id,
					label,
					type,
					hid,
					esn,
					imei,
					driverId,
					unitVersionId,
					deviceCategory,
					locationId,
					useEcuOdometer,
					offsetEngineOdometer,
					offsetEcuEngineOdometer,
					useEcuEngineHours,
					offsetEngineHours,
					offsetEcuEngineHours,
					useEcuSpeed,
					timeZoneId,
					useEcuVin,
					notes,
					offsetEngineOdometerUpdatedOn,
					offsetEcuEngineOdometerUpdatedOn,
					offsetEngineHoursUpdatedOn,
					offsetEcuEngineHoursUpdatedOn,
					tagIds,
					vehicleStatusId,
					consistentSpeed: consistentSpeed || 0,
					consistentDuration: consistentDuration || 0,
					lowBattery: lowBattery ? 1 : 0,
					noGps: noGps ? 1 : 0,
					noGpsTimes: noGpsTimes || 0,
					noGpsDays: noGpsDays || 0,
					alertContacts: alertContacts?.length ? alertContacts : [],
					driverTransitionFrom:"CloudWebSite",
					...(typeof defaultDriverId !== "undefined" ? { defaultDriverId: defaultDriverId } : {})
				},
				endpoints.GRAPHQL_GENERAL,
			);

			if (data && data.updateUnit) {
				for (let input of inputs?.d) {
					yield call(
						clientMutation,
						` mutation deleteUnitInput ($unitId: Int!, $position: Int!) {
							deleteUnitInput (unitId: $unitId, position: $position)
						}`,
						{
							unitId: input.unitId,
							position: input.position
						},
						endpoints.GRAPHQL_GENERAL,
					);
				}

				for (let input of inputs?.c) {
					yield call(
						clientMutation,
						` mutation createUnitInput ($unitId: Int!, $position: Int!, $labelId: Int!) {
							createUnitInput (unitId: $unitId, position: $position, labelId: $labelId) {
								unitId
							}
						}`,
						{
							unitId: input.unitId,
							position: input.position,
							labelId: input.labelId
						},
						endpoints.GRAPHQL_GENERAL,
					);
				}

				for (let input of inputs?.u) {
					yield call(
						clientMutation,
						` mutation updateUnitInput ($unitId: Int!, $position: Int!, $labelId: Int!) {
							updateUnitInput (unitId: $unitId, position: $position, labelId: $labelId) {
								unitId
							}
						}`,
						{
							unitId: input.unitId,
							position: input.position,
							labelId: input.labelId
						},
						endpoints.GRAPHQL_GENERAL,
					);
				}

				for (let output of outputs?.c) {
					yield call(
						clientMutation,
						` mutation createUnitOutput ($unitId: Int!, $position: Int!, $name: String!, $type: enumOutputType!, $state: enumOutputState!) {
							createUnitOutput (unitId: $unitId, position: $position, name: $name, type: $type, state: $state) {
								unitId
							}
						}`,
						{
							unitId: output.unitId,
							position: output.position,
							name: output.name,
							type: output.type,
							state: output.state
						},
						endpoints.GRAPHQL_GENERAL,
					);
				}

				for (let output of outputs?.u) {
					yield call(
						clientMutation,
						` mutation updateUnitOutput ($unitId: Int!, $position: Int!, $name: String!, $type: enumOutputType!, $state: enumOutputState!) {
							updateUnitOutput (unitId: $unitId, position: $position, name: $name, type: $type, state: $state) {
								unitId
							}
						}`,
						{
							unitId: output.unitId,
							position: output.position,
							name: output.name,
							type: output.type,
							state: output.state
						},
						endpoints.GRAPHQL_GENERAL,
					);
				}

				if (systemAlertsToDelete?.length) {
					yield put(deleteAlerts(systemAlertsToDelete, "", ""));
				}

				for (let systemAlert of systemAlerts) {
					if (systemAlert?.id) {
						yield put(AlertsUpdateSystemAlert(systemAlert));
					} else {
						yield put(AlertsCreateSystemAlert(systemAlert));
					}
				}

				const assetId = asset?.id || id;

				yield put(upsertRealtimeUnits([{
					id,
					useEcuVin: !!useEcuVin,
				}]));

				yield put(upsertRealtimeLastReadings([{
					deviceId: id,
					id,
					vin: asset?.vin,
					ecuVin: unit?.ecuVin,
					ignoreValidation: true,
				}]));

				yield put(upsertRealtimeAssets([{
					id: assetId,
					unitId: id,
					vin: asset?.vin,
					ecuVin: unit?.ecuVin,
					make: asset?.make,
					model: asset?.model,
					year: asset?.year,
					licensePlate: asset?.licensePlate,
				}]));

				yield put(unitEditUpdateResult(true));
			} else throw 'could not update unit';
		} catch (exc) {
			ExceptionManager(
				exc,
				'modules/units/components/editUnit/redux/saga',
				'requesUpdateUnit',
			);
			yield put(unitEditUpdateResult(false, exc));
		}
	});
}

export function* sendOtaRequest() {
	yield takeEvery(EDIT_UNIT_SEND_OTA, function* ({ payload }) {
		try {
			const response = yield call(
				clientMutation,
				` 
					mutation sendOta(
						$units: [UnitInfoInput]
        				$command: String!
						$noUserId: Boolean
					) {
						ota: sendOta(
							units: $units
							command: $command
							noUserId: $noUserId
						) {
							otaId
							command
							errorMessage
						}
					}
				`,
				{ ...payload, noUserId: true },
				endpoints.GRAPHQL_GENERAL,
			);

			if (response?.ota) {
				yield put(sendOtaResult({ ...response?.ota, error: false }));
			}
		} catch (exc) {
			ExceptionManager(
				exc,
				'modules/units/components/editUnit/redux/saga',
				'sendOtaRequest',
			);
			yield put(sendOtaResult({ error: true }));
		}
	});
}

export function* sendPingRequest() {
	yield takeEvery(EDIT_UNIT_SEND_PING, function* ({ payload }) {
		try {
			const response = yield call(
				clientMutation,
				` 
					mutation sendPingBySMS(
						$unitIds: [Int]!,
        				$message: String
					) {
						ping: sendPingBySMS(
							unitIds: $unitIds
							message: $message
						) {
							unitId,
							outId,
							errorMessage
						}
					}
				`,
				payload,
				endpoints.GRAPHQL_GENERAL,
			);

			if (response?.ping) {
				yield put(sendPingResult({ ...response?.ping, error: false }));
			}
		} catch (exc) {
			ExceptionManager(
				exc,
				'modules/units/components/editUnit/redux/saga',
				'sendPingRequest',
			);
			yield put(sendPingResult({ error: true }));
		}
	});
}

export function* decodeVinRequest() {
	yield takeEvery(EDIT_UNIT_DECODE_VIN, function* ({ payload }) {
		try {
			const { data } = payload;
			const url = `${endpoints.NHTSA_URL}/api/vehicles/decodevinvaluesextended/${data?.vin}?format=json`;
			const result = yield call(clientGET, '', {}, url, false);

			let asset = null;
			if (result && result?.Results && result?.Results?.length) {
				asset = result?.Results[0];
			}

			if (!asset?.VIN) {
				yield put(decodeVinResponse({ error: true }));
			} else {
				yield put(decodeVinResponse(asset));
			}
		} catch (exc) {
			yield put(decodeVinResponse({ error: true }));
			ExceptionManager(
				exc,
				"modules/units/components/editUnit/redux/saga",
				"decodeVinRequest"
			);
		}
	});
}

//Saga Export
export default function* rootSaga() {
	yield all([
		fork(requesGetUnit),
		fork(requesUpdateUnit),
		fork(sendOtaRequest),
		fork(sendPingRequest),
		fork(decodeVinRequest)
	]);
}
